import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../App.css";

const OurServicesDetails = () => {

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <div className="about-section padding-container">
      <div className="page-wrapper">
        <div className="about-us">

          <div className="about-1" data-aos="fade-up" data-aos-duration="1000">
            <h1 className= "services_headings">
              WHY WORK WITH <span className="orange-text">US?</span>
            </h1>

            <h1 className= "services_headings">
            A Culture of
              <span className="orange-text"> Learning & Growth</span>
            </h1>

            <p>
              We invest in people. From training sessions and design/development workshops to participation in real-world client projects, we ensure every team member progresses steadily in their career. You will work with experienced designers, developers, and digital strategists who help you refine your craft and grow professionally.
            </p> <br />

            <h1 className= "services_headings">
              OPPORTUNITIES ACROSS 
              <span className="orange-text"> MULTIPLE DEPARTMENTS:</span>
            </h1>
            <p>
              As a multi-disciplinary company, we offer diverse roles ranging from technical development to digital creativity. Whether your interest lies in code, design, or digital marketing, we have a pathway for your career.
            </p> <br />

            <h1 className= "services_headings">
              WORK ON 
              <span className="orange-text"> GLOBAL PROJECTS</span>
            </h1>
            <p>
              VisionBird Technologies works with clients worldwide from various industries. You’ll get the opportunity to work on real international projects, giving you valuable experience across different technologies and design practices.
            </p> <br />

            <h1 className= "services_headings">
              PROFESSIONAL, RESPECTFUL &
              <span className="orange-text"> STRUCTURED ENVIRONMENT</span>
            </h1>
            <p>
              We follow a corporate structure that maintains professionalism, discipline, and teamwork. Every department operates with clear responsibilities, timelines, and performance standards that help you build strong professional skills.
            </p> <br />

            <h1 className= "services_headings">
              MODERN WORKSPACE
              <span className="orange-text"> & TOOLS</span>
            </h1>
            <p>
              We operate with modern software, updated technologies, high-end systems, and premium tools to ensure that our employees work efficiently without limitations.
            </p> <br />

            <h1 className= "services_headings">
           DEPARTMENTS 
              <span className="orange-text"> & CAREER PATHS</span>
            </h1>
            <p>
              Below are the primary areas in which we frequently hire talented individuals:
            </p> <br />

          </div>

        </div>
      </div>
    </div>
  );
};

export default OurServicesDetails;
